<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!changelogSelected) {
        <h1 class="title">Crear Version</h1>
      }
    </div>
    <div class="title-color">
      @if (changelogSelected) {
        <h1 class="title">Editar Version</h1>
      }
    </div>
    <br>
    <div class="form-body">
      <form [formGroup]="changelogForm" (ngSubmit)="saveChangelog()">
        <div class="form-grid cols-2">
            <mat-form-field appearance="outline">
              <mat-label>Versión</mat-label>
              <input
                type="text"
                matInput
                name="version"
                id="version"
                formControlName="version"
                placeholder="Ej: 1.0.0"
                maxlength="10"
              />
              @if (changelogForm.get('version')?.hasError('required')) {
              <mat-error
                class="for-text text-danger"
              >
                Campo obligatorio
              </mat-error>
            }
            </mat-form-field>

          <!-- Fecha de Lanzamiento -->
            <mat-form-field appearance="outline">
              <mat-label>Fecha de lanzamiento</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                name="releaseDate"
                id="releaseDate"
                formControlName="releaseDate"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (changelogForm.get('releaseDate')?.hasError('required')) {
              <mat-error
                class="for-text text-danger"
              >
                Campo obligatorio
              </mat-error>
            }
            </mat-form-field>
        </div>
        <br>
          <!-- Nuevas Características -->
           <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nuevas características</mat-label>
              <textarea
                matInput
                rows="3"
                name="featureDesc"
                id="featureDesc"
                formControlName="featureDesc"
                placeholder="Describa las nuevas características..."
              ></textarea>
               @if (changelogForm.get('featureDesc')?.hasError('required')) {
              <mat-error
                class="for-text text-danger"
              >
                Campo obligatorio
              </mat-error>
            }
            </mat-form-field>
            <br>
          <!-- Corrección de Errores -->
            <mat-form-field appearance="outline">
              <mat-label>Corrección de errores</mat-label>
              <textarea
                matInput
                rows="3"
                name="bugFixesDesc"
                id="bugFixesDesc"
                formControlName="bugFixesDesc"
                placeholder="Describa las correcciones realizadas..."
              ></textarea>
              @if (changelogForm.get('bugFixesDesc')?.hasError('required')) {
              <mat-error
                class="for-text text-danger"
              >
                Campo obligatorio
              </mat-error>
            }
            </mat-form-field>
          </div>
          <br>
        <button type="submit" class="primary-button" [disabled]="!changelogForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
        </form>
    </div>
  </div>
</div>
